<template>
  <div class="dial-code-item compact-text" :class="{ actionable, selected, mobile }">
    <span class="item-flag -mr_1" :style="`background: url(${flag});`" />
    <span class="item-text">
      <span class="item-label">
        {{ label }}
      </span>
    </span>
  </div>
</template>

<script>


export default {
  name: 'dialCodeItem',
  props: {
    label: {
      type: String,
      default: '',
    },
    countryCode: {
      type: String,
      default: null,
    },
    actionable: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    mobile: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    flag() {
      return `https://cdn.swordhealth.tech/assets/media/flags/${this.countryCode}.svg`;
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin option-item {
  height: 2.5rem;
  font-size: 0.875rem;
}

@mixin option-item-mobile {
  height: 3rem;
  padding: map-get($sh-spacers-wuk, 2);
}

.dial-code-item {
    @include option-item;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: $dial-code-color;
    cursor: pointer;

    @media screen and (max-width: $max-smartphone-size) {
      @include option-item-mobile;
    }

    &.disabled {
      color: $dial-code-disabled-color;
      cursor: default;
      pointer-events: none;
    }

    &.actionable {
      &:hover:not(.disabled, .selected, .mobile) {
        color: $dial-code-hover-color;
      }

      &.selected.mobile {
        background-color: $dial-code-mobile-background;
      }
    }


    &.selected {
      font-weight: $dial-code-selected-item-weight;
    }

    .item-flag {
      flex: none;
      border-radius: 2px;
      width: 1.5rem;
      height: 1rem;
      background-size: contain;
    }

    .item-text {
      display: flex;
      min-width: 1px;
      flex-grow: 1;

      .item-label {
        @extend %compact-text;
      }
    }
  }


</style>
